import { CommonModule } from '@angular/common';
import { Component, Inject, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { AssetPublishingStatus, AssetUIModel, ClientCoreModule, ClientEnvironment, ENVIRONMENT, getAssetPublishingStatus } from '@thehubz/client/core';
import { CustomClients } from '@thehubz/shared/branding';
import { AssetPublishingMessagePipe } from '../../../pipes/asset-publishing-message.pipe';
import { AssetCommonService } from '../../../services/asset-common.service';

@Component({
  selector: 'thehubz-asset-notifications',
  templateUrl: './asset-notifications.component.html',
  styleUrls: ['./asset-notifications.component.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, ClientCoreModule, AssetPublishingMessagePipe],
})
export class AssetNotificationsComponent implements OnChanges {
  @Input() asset!: AssetUIModel;

  assetExpiryDays?: number;
  brandingKey!: CustomClients;
  CustomClients = CustomClients;
  constructor(private assetCommonService: AssetCommonService, @Inject(ENVIRONMENT) private readonly env: ClientEnvironment) {
    this.brandingKey = env.brandingKey ?? CustomClients.Standard;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['asset'].currentValue) {
      this.asset = changes['asset'].currentValue;
      this.assetExpiryDays = this.assetCommonService.getAssetExpireDays(this.asset?.expiryDate);
    }
  }

  getIsAssetPublished(asset: AssetUIModel): boolean {
    const publishingStatus = getAssetPublishingStatus(asset);
    const statuses = [AssetPublishingStatus.PLANNED, AssetPublishingStatus.UNPUBLISHED];
    if (statuses.includes(publishingStatus)) return false;
    return true;
  }
}
